import { render, staticRenderFns } from "./CandidateDetail.vue?vue&type=template&id=514f59bc"
import script from "./CandidateDetail.vue?vue&type=script&lang=js"
export * from "./CandidateDetail.vue?vue&type=script&lang=js"
import style0 from "./CandidateDetail.vue?vue&type=style&index=0&id=514f59bc&prod&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports